module.exports = __webpack_public_path__ + "assets/img/e7e141254994c97d2ed5ad570a42e0db.png";